var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ii-status-pill",class:_vm.isActive ? 'ii-status-pill--active' : 'ii-status-pill--inactive'},[_c('span',{staticClass:"ii-status-pill__dot"}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }